import { useEffect } from 'react';

const useOnClickOutside = (ref, handler, enabled = true, portalId) => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (
        !ref ||
        !ref.current ||
        ref.current.contains(event.target) ||
        (portalId && document.getElementById(portalId).contains(event.target))
      ) {
        return;
      }

      handler?.(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, enabled, portalId]);
};

export default useOnClickOutside;
